// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { analytics } from "./firebase";
import { logEvent } from "firebase/analytics";

import Footer from "./components/Footer";
import HomeScreen from "./screens/HomeScreen";
import ProductPage from "./pages/ProductPage";
import CheckoutPage from "./pages/CheckoutPage";
import SignUpScreen from "./screens/SignUpScreen";
import LoginScreen from "./screens/LoginScreen";
import CollectionPage from "./pages/CollectionPage";
import ThankYouPage from "./pages/ThankYouPage";

// Tracks a page view whenever the route changes
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_title: document.title,
    });
    console.log("[Analytics] Page view:", location.pathname);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/checkout/:id" element={<CheckoutPage />} />
        <Route path="/sign-in" element={<LoginScreen />} />
        <Route path="/sign-up" element={<SignUpScreen />} />
        <Route path="/collection/:id" element={<CollectionPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
